import styled from '@emotion/styled';
import { Fragment, SyntheticEvent } from 'react';
import { Colors, Text } from '@zapier/design-system';

type OptionShape = {
  id: string;
  label: string;
  onChange: (e: SyntheticEvent) => void;
};

const Option = ({ id, label, onChange }: OptionShape) => {
  return (
    <Fragment>
      <Input
        id={id}
        name="mp-survey"
        onChange={onChange}
        type="radio"
        value={id}
      />
      <Label htmlFor={id}>
        <Text fontWeight={600} type="smallPrint1">
          {label}
        </Text>
      </Label>
    </Fragment>
  );
};

export { Option };

const Input = styled.input`
    border: 0;
    clip: rect(0px 0px 0px 0px);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;

    + label:before {
      border-color: ${Colors.gray40};
    },

    &:checked + label:before {
      background-color: ${Colors.blueJeans};
      border-color: ${Colors.blueJeans};
    },

    &:focus + label:before {
      box-shadow: 0 0 2px 2px ${Colors.blueJeans};
    },
`;

const Label = styled.label`
    align-items: center;
    display: flex;
    margin-right: 10px;

    &:before {
      content: '';
      background-clip: content-box;
      background-color: transparent;
      border-radius: 100%;
      border-style: solid;
      border-width: 2px;
      box-sizing: content-box;
      display: inline-block;
      height: 10px;
      margin-right: 8px;
      padding: 3px;
      vertical-align: -3;
      width: 10px;
    },

    &:hover {
      cursor: pointer;
    },
`;
